import type { ClientCreateInput, ClientUpdateInput, FollowupCompleteInput, FollowupCreateInput, LeadActivityInput, LeadCreateInput, LeadUpdateInput } from '@stoplord/shared';
import { api } from '@/lib/api';
import type { Client, ClientDetail, Followup, Lead, LeadDetail } from './types';

type Q = Record<string, string | number | undefined>;

export const leadsApi = {
  list: (q: Q) => api.page<Lead>('/crm/leads', q),
  get: (id: string) => api.get<LeadDetail>(`/crm/leads/${id}`),
  create: (body: LeadCreateInput) => api.post<Lead>('/crm/leads', body),
  update: (id: string, body: LeadUpdateInput) => api.patch<Lead>(`/crm/leads/${id}`, body),
  remove: (id: string) => api.delete(`/crm/leads/${id}`),
  stage: (id: string, stage: string, lostReason?: string) => api.post<Lead>(`/crm/leads/${id}/stage`, { stage, lostReason }),
  assign: (id: string, ownerId: string, sharedWith?: string[], note?: string) => api.post<Lead>(`/crm/leads/${id}/assign`, { ownerId, sharedWith, note }),
  activity: (id: string, body: LeadActivityInput) => api.post(`/crm/leads/${id}/activities`, body),
  followup: (id: string, body: FollowupCreateInput) => api.post<Followup>(`/crm/leads/${id}/followups`, body),
  convert: (id: string, body: { clientName?: string; existingClientId?: string }) => api.post<{ clientId: string }>(`/crm/leads/${id}/convert`, body),
};

export const followupsApi = {
  list: (q: Q) => api.page<Followup>('/crm/followups', q),
  complete: (id: string, body: FollowupCompleteInput) => api.post(`/crm/followups/${id}/complete`, body),
  cancel: (id: string) => api.post(`/crm/followups/${id}/cancel`),
};

export const clientsApi = {
  list: (q: Q) => api.page<Client>('/crm/clients', q),
  get: (id: string) => api.get<ClientDetail>(`/crm/clients/${id}`),
  create: (body: ClientCreateInput) => api.post<Client>('/crm/clients', body),
  update: (id: string, body: ClientUpdateInput) => api.patch<Client>(`/crm/clients/${id}`, body),
  note: (id: string, summary: string, type = 'note') => api.post(`/crm/clients/${id}/notes`, { summary, type }),
  remove: (id: string) => api.delete(`/crm/clients/${id}`),
};
